import * as yup from 'yup';

import { useTranslations } from '../../../../../../contexts/LocalizationContext';
import { INVENTORY_COUNT_INVENTORY_MIN_VALUE } from '../../../utils/inventory-counts.consts';

export const useInventoryCountInventoryValidationSchema = (): yup.AnyObjectSchema => {
  const translations = useTranslations();

  return yup.object().shape({
    shouldStock: yup.string().test(
      'has-correct-value',
      translations('inventory_counts_inventory_min_value', {
        '{{min-value}}': INVENTORY_COUNT_INVENTORY_MIN_VALUE.toString(),
      }),
      (value) => Number(value) >= INVENTORY_COUNT_INVENTORY_MIN_VALUE,
    ),
    actualStock: yup.string().test(
      'has-correct-value',
      translations('inventory_counts_inventory_min_value', {
        '{{min-value}}': INVENTORY_COUNT_INVENTORY_MIN_VALUE.toString(),
      }),
      (value) => Number(value) >= INVENTORY_COUNT_INVENTORY_MIN_VALUE,
    ),
  });
};
